const News = {

    opening: false,
    state: 'opened',

    update: function(news_id) {
        let content = document.getElementById(`news_content_${news_id}`);
        let button_message = document.getElementById(`news_button_spoiler_${news_id}`);
        let button_icon = document.getElementById(`news_button_icon_${news_id}`);
        let state = content.dataset.state;

        if (!News.opening) {
            News.opening = true;

            if (state==="closed") {
                content.dataset.state = "opened";
                //content.setAttribute("data-state", "opened");
                content.classList.add("animated");
                content.classList.add("bounceInUp");
                content.classList.remove("fadeOut");
                content.classList.remove("d-none");
                button_message.innerHTML = "Ocultar";
                button_icon.classList.remove("glyphicons-eye");
                button_icon.classList.add("glyphicons-eye-off");
            } else {
                content.dataset.state = "closed";
                //content.setAttribute("data-state", "closed");

                button_message.innerHTML = "Leer más";
                button_icon.classList.add("glyphicons-eye");
                button_icon.classList.remove("glyphicons-eye-off");
                content.classList.add("animated");
                content.classList.remove("bounceInUp");
                content.classList.add("fadeOut");
                setTimeout(() => {
                    content.classList.add("d-none");
                }, 500)
            }


            News.opening = false;
        }
    }


}
